




























































import Vue from "vue";
import { mapGetters } from "vuex";
import {updateClassified} from "@/shared/scripts/ValidateData";
import {deleteOrderPublishPictures} from "@/shared/scripts/UploadPicture";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { app } from "@/main";

export default Vue.extend({
    components: {
        iwTooltip: iwTooltip
    },

    data: function() {
        return {
            isMobile: true as boolean,
            specificId: uuidv4() as string
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
            hasApiErrors: "FormModule/hasErrors",
        })
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },

    methods: {
        goBackToMyClassifieds: function() {
            this.$store.commit("ModalModule/openEditionModal");
        },
        publishChanges: function() {
            if(!this.hasApiErrors) {
                this.$store.commit("ModalModule/openWarningModal");
            }
            deleteOrderPublishPictures(true).then(() => {
                updateClassified((success: boolean) => {
                    if(success) {
                        let urlTranslated = this.$t("my-immoweb") as string;
                        const to = this.$router.resolve({path: urlTranslated});
                        this.$router.push(to.location);
                    }
                    if(!this.hasApiErrors) {
                        this.$store.commit("ModalModule/openWarningModal");
                    }
                });
            }).catch(() => {
                app.dialog.alert(i18n.t("server_not_responding_error").toString());
            });
        },
    }

});
